import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import facebook from "@/shared/assets/facebook.svg";
import footerPhone from "@/shared/assets/footer-phone.svg";
import instagram from "@/shared/assets/instagram.svg";
import linkedin from "@/shared/assets/linkedin.svg";
import logo from "@/shared/assets/logo.svg";
import mail from "@/shared/assets/mail.svg";
import telegram from "@/shared/assets/telegram.svg";
import youtube from "@/shared/assets/youtube.svg";

const SOCIALS = [
  { name: "Facebook", icon: facebook },
  { name: "LinkedIn", icon: linkedin },
  { name: "YouTube", icon: youtube },
  { name: "Instagram", icon: instagram },
  { name: "Telegram", icon: telegram },
];

/** Footer from Figma: rounded top, link columns, contacts, socials, legal row. */
export function Footer() {
  const { t } = useTranslation(["shop", "common"]);
  const columns = [
    [
      ["deliveryTerms", "/delivery"],
      ["returns", "/legal/offer"],
      ["promoRules", "/promo"],
    ],
    [
      ["about", "/legal"],
      ["social", "/legal"],
      ["career", "/legal"],
      ["partners", "/legal"],
    ],
  ] as const;

  return (
    <footer className="mt-10 rounded-t-3xl bg-surface text-body-sm text-muted lg:mt-20 lg:rounded-t-4xl lg:bg-canvas">
      <div className="container-page grid gap-8 pt-10 pb-6 sm:grid-cols-2 lg:grid-cols-4">
        <img src={logo} width={120} height={20} alt={t("common:brand")} />
        {columns.map((keys, index) => (
          <ul key={index} className="flex flex-col gap-3">
            {keys.map(([key, to]) => (
              <li key={key}>
                <Link to={to} className="hover:text-brand-600">
                  {t(`footer.${key}`)}
                </Link>
              </li>
            ))}
          </ul>
        ))}
        <div className="flex flex-col gap-3">
          <p className="text-sm font-semibold text-ink-strong">{t("footer.contacts")}</p>
          <a href="tel:+998735152222" className="flex items-center gap-2 hover:text-brand-600">
            <img src={footerPhone} width={16} height={16} alt="" />
            73 515 22 22
          </a>
          <a
            href="mailto:info@ishonchsavdo.uz"
            className="flex items-center gap-2 hover:text-brand-600"
          >
            <img src={mail} width={16} height={16} alt="" />
            info@ishonchsavdo.uz
          </a>
          <ul className="mt-2 flex gap-3">
            {SOCIALS.map((social) => (
              <li key={social.name}>
                <img src={social.icon} width={24} height={24} alt={social.name} />
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="container-page flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-line py-5">
        <Link to="/legal/offer" className="hover:text-brand-600">
          {t("footer.offer")}
        </Link>
        <Link to="/legal/privacy" className="hover:text-brand-600">
          {t("footer.privacy")}
        </Link>
        <span className="ml-auto">{t("footer.copyright", { year: new Date().getFullYear() })}</span>
      </div>
    </footer>
  );
}
